import PropTypes from 'prop-types';

export const activityInputPropTypes = {
  defaultActivity: PropTypes.string,
  urlPrefix: PropTypes.string,
  formActive: PropTypes.bool, // true when other inputs in the form are focused
  value: PropTypes.exact({
    label: PropTypes.string,
    value: PropTypes.object // activity object from backend
  }),
  setValue: PropTypes.func, // ({ label, value: { activity obj } }) => void
  setActiveInput: PropTypes.func, // (string) => void
  setValidator: PropTypes.func // validatorFn) => boolean
};
